import { AccountPage } from "./components/account/AccountPage";
import Layout from "./components/ui/Layout";

export const Account = () => {
  return (
    <Layout>
      <AccountPage />
    </Layout>
  );
};
